import { useTranslation } from "react-i18next";
import Drug from "../drug/Drug";
import SwitchView from "./SwitchView";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useState } from "react";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import { Consts } from "../pages/consts";
import DrugsTable from "./DrugsTable";
import {hospitalLanguages} from "../../resources/json/jsons";

const TabularView = ({
  selectedPatient,
  patDrugs,
  onDeleteDrug,
  setDrugsView,
  showSwitch = true,
  errorParent,
  loadingParent,
  onReceiveAndHandlePrescriptions
}) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);
  const [addDrug, setAddDrug] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const [allProductNames, setAllProductNames] = useState([]); // drug ProductNames prepared for select elements with value and label keys
  const [allSubstances, setAllSubstances] = useState([]); // drug active Substances prepared for select elements with value and label keys

  const {
    loading,
    error,
    clearError,
    getDrugProductsJson,
    getDrugSubstancesJson,
    saveDbDrug
  } = useMmcService();

  const language = hospitalLanguages[context?.studyBranch];

  useEffect(() => {
    clearError();

    getDrugProductsJson(context?.token, language) // "product" and "substance" - searching kinds
      .then((data) => setAllProductNames(data));
  }, []);

  useEffect(() => {
    clearError();

    getDrugSubstancesJson(context?.token, language) // "product" and "substance" - searching kinds
      .then((data) => setAllSubstances(data));
  }, []);

  const handleAddDrug = () => {
    setAddDrug(true);
  };

  const saveDrug = (drug) => {
    clearError();
    setAddDrug(false);

    const patientId = !selectedPatient
      ? context?.patient?.id
      : selectedPatient?.id;

    saveDbDrug(context?.token, drug, patientId)
      .then(() => {
        onReceiveAndHandlePrescriptions().then();
        // setAddDrug(false);
      });
  };

  let message =
    errorParent && errorParent?.includes(Consts.DELETE)
      ? t("error_by_deleting_a_drug")
      : t("error_by_retrieving_prescribed_drugs");

  message =
    error && error?.includes(Consts.INTERACTION)
      ? t("error_by_retrieving_drug_drug_interactions")
      : message;

  const errorMessage = (error || errorParent) && (
    <ErrorMessage message={message} />
  );

  const spinner = (loading || loadingParent) && <Spinner />;

  return (
    <>
      {addDrug && (
        <Drug
          onSaveDrug={saveDrug}
          onHandleAddDrug={setAddDrug}
          allProductNames={allProductNames}
          allSubstances={allSubstances}
          patDrugs={patDrugs}
          language={language}
        />
      )}
      {context?.role !== Consts.PATIENT ? (
        <div className={`medication-view medication-tabular medication-tabular--hcp ${selectedPatient ? "medication-view--dialog-wide-match" : ""}`}>
          {errorMessage}
          {spinner}
          <section className="medication-tabular__panel">
            {patDrugs?.length > 1 && showSwitch && (
              <div className="medication-tabular__toolbar symptom-toolbar-actions switch-view-right-edge">
                <SwitchView
                  setDrugsView={setDrugsView}
                  viewName={Consts.GRAPH}
                  label={t("to_graph_view")}
                />
              </div>
            )}
            <DrugsTable
              patDrugs={patDrugs}
              onDeleteDrug={onDeleteDrug}
              onAddDrug={handleAddDrug}
              loading={loading || loadingParent}
            />
          </section>
        </div>
      ) : (
        <div className="w3-display-container content-container content-container-full medication-tabular-shell">
          <div className="medication-view medication-tabular medication-tabular--patient">
            <div className="medication-tabular__identity">
              <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
            </div>
            <div className="w3-center form-display-drugs medication-content">
              <div className="w3-panel w3-card-4 record-panel medication-tabular__record-panel">
                <header className="w3-container w3-center medication-tabular__patient-header">
                  <div className="w3-display-container w3-padding-small medication-tabular__patient-header-inner">
                    <h2>
                      {context?.role === Consts.PATIENT
                        ? t("your_medication_pat")
                        : t("your_medication")}
                    </h2>
                    {patDrugs?.length > 1 && showSwitch && (
                      <div className="w3-display-right symptom-toolbar-actions switch-view-right-edge medication-tabular__patient-switch">
                        <SwitchView
                          setDrugsView={setDrugsView}
                          viewName={Consts.GRAPH}
                          label={t("to_graph_view")}
                        />
                      </div>
                    )}
                  </div>
                </header>
                {showDisclaimer && (
                  <div className="w3-row-padding medication-tabular__disclaimer-wrap">
                    <div className="w3-panel w3-card-4 disclaimer-background medication-tabular__disclaimer-card medication-tabular__disclaimer-panel">
                      <div className="medication-tabular__disclaimer-header">
                        <span className="medication-tabular__disclaimer-title">{t("safety_information_for_medication")}</span>
                        <FontAwesomeIcon
                          icon={faXmark}
                          className="modal-close medication-tabular__disclaimer-close"
                          onClick={() => setShowDisclaimer(false)}
                        />
                      </div>
                      <div className="disclaimer-text">
                        ⚠️ {t("drug_disclaimer")} {t("drug_disclaimer_2")} {" "}
                        {t("drug_disclaimer_3")}
                      </div>
                    </div>
                  </div>
                )}
                {errorMessage}
                {spinner}
                <DrugsTable
                  patDrugs={patDrugs}
                  onDeleteDrug={onDeleteDrug}
                  onAddDrug={handleAddDrug}
                  loading={loading || loadingParent}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TabularView;
